var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCisIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#2CB2A5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12975_180467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3813 10.4556H15.8144C15.1604 10.4556 14.6211 10.9834 14.6211 11.6489V13.9668C14.6211 14.6208 15.1604 15.1601 15.8144 15.1601H20.3813C21.0353 15.1601 21.5746 14.6208 21.5746 13.9668V11.6489C21.5746 10.9834 21.0468 10.4556 20.3813 10.4556ZM20.7829 13.9668C20.7829 14.1848 20.6108 14.3684 20.3813 14.3684H15.8144C15.5964 14.3684 15.4128 14.1962 15.4128 13.9668V11.6489C15.4128 11.4309 15.5849 11.2473 15.8144 11.2473H20.3813C20.5993 11.2473 20.7829 11.4194 20.7829 11.6489V13.9668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8067 12.8882H9.19334C8.52783 12.8882 8 13.4275 8 14.0815V24.3397C8 24.9937 8.52783 25.533 9.19334 25.533H26.8067C27.4607 25.533 28 24.9937 28 24.3397V14.0815C28 13.4275 27.4607 12.8882 26.8067 12.8882ZM20.9432 19.6925H18.8778V21.7694H17.3287V19.6925H15.2519V18.155H17.3287V16.0781H18.8778V18.155H20.9547V19.6925H20.9432Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12975_180467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 15.0889,
    fill: "white",
    transform: "translate(8 10.4556)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCisIcon);
export default __webpack_public_path__ + "static/media/CIS_icon.09accc32.svg";
export { ForwardRef as ReactComponent };